getPmScreenErrorCreated